import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import 'bootstrap/js/dist/carousel';
import { dataInformes as defaultDataInformes } from '../../../data/dataInformes';
import './Informes.css';

// Bandera para rediseño de documentos en cuadros uniformes (Tablet y PC >= 768px)
const USAR_DOCS_CUADRADOS = true;

const Informes = ({ items: propItems, itemsID }) => {
  const items = propItems || defaultDataInformes;
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [groupSize, setGroupSize] = useState(3);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [hoverPosition, setHoverPosition] = useState({ top: 0, left: 0 });
  const [showModal, setShowModal] = useState(false);
  const [modalImage, setModalImage] = useState('');

  // Tablet y PC (>= 768px)
  const isTabletOrDesktop = windowWidth >= 768;
  const esModoCuadros = USAR_DOCS_CUADRADOS && isTabletOrDesktop;

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setWindowWidth(width);
      if (USAR_DOCS_CUADRADOS && width >= 768) {
        setGroupSize(width >= 1280 ? 6 : width >= 1024 ? 5 : 3);
      } else {
        setGroupSize(width < 768 ? 1 : width < 992 ? 2 : 3);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleOpenModal = (imageUrl) => {
    setModalImage(imageUrl);
    setShowModal(true);
  };

  // Agrupamiento exacto por vista sin duplicados para modo cuadros
  const createExactGroups = (list, size) => {
    const groups = [];
    for (let i = 0; i < list.length; i += size) {
      groups.push(list.slice(i, i + size));
    }
    return groups;
  };

  // Agrupamiento original
  const createInfiniteGroups = (itemsList, size) => {
    const groups = [];
    const totalGroups = Math.ceil(itemsList.length / size);
    
    for (let i = 0; i < totalGroups; i++) {
      const group = [];
      for (let j = 0; j < size; j++) {
        const itemIndex = (i * size + j) % itemsList.length;
        group.push(itemsList[itemIndex]);
      }
      groups.push(group);
    }
    return groups;
  };

  const groups = esModoCuadros
    ? createExactGroups(items, groupSize)
    : createInfiniteGroups(items, groupSize);

  const getDynamicHeight = () => {
    if (windowWidth < 768) return 180;
    if (windowWidth < 992) return 220;
    if (windowWidth < 1200) return 250;
    return 280;
  };

  const handleMouseEnter = (item, event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    const windowCenter = window.innerWidth / 2;
    const previewWidth = getDynamicHeight() * 2.2; 
    
    setHoverPosition({
      top: rect.top + window.scrollY - (getDynamicHeight() * 0.5), 
      left: windowCenter - (previewWidth / 2)
    });
    setHoveredItem(item);
  };

  return (
    <div className="position-relative">
      {/* Modal para Ubica tu Casilla */}

      
      {/* <Modal 
        show={showModal} 
        onHide={() => setShowModal(false)} 
        centered
        size="lg"
        className="custom-modal"
      >
        <Modal.Header closeButton className="border-0 position-absolute top-0 end-0 z-1" />
        
        <Modal.Body className="p-0 d-flex flex-column flex-lg-row" style={{ maxHeight: "90vh" }}> */}
          {/* Columna Imagen */}
          {/* <div className="d-flex align-items-center justify-content-center p-2 p-lg-3" style={{
            width: "100%",
            minHeight: "200px",
            maxHeight: "400px",
            backgroundColor: '#f0f0f0',
            overflow: 'hidden',
            flexShrink: 0
          }}>
            <img
              src={modalImage}
              alt="Ubica tu Casilla"
              className="img-fluid"
              style={{ 
                height: "100%",
                width: "auto",
                maxWidth: "100%",
                objectFit: "contain"
              }}
            />
          </div> */}
          
          {/* Columna Botones */}
          {/* <div className="d-flex flex-column p-3 p-lg-4 justify-content-center" style={{
            width: "100%",
            height: "auto",
            gap: "12px",
            backgroundColor: "#f8f9fa",
            overflowY: "auto"
          }}>
            <button
              className="btn-hover-effect"
              style={{
                backgroundColor: "#8D077B",
                color: "white",
                border: "none",
                padding: "12px",
                fontSize: "1rem",
                fontWeight: "bold",
                borderRadius: "6px",
                transition: "all 0.3s ease",
                boxShadow: "0 4px 6px rgba(0,0,0,0.1)"
              }}
              onClick={() => window.open("https://ubicatucasilla.ine.mx/", "_blank")}
            >
              Ubica tu Casilla
            </button>

     
            <button
              className="btn-hover-effect"
              style={{
                backgroundColor: "#E55398",
                color: "white",
                border: "none",
                padding: "12px",
                fontSize: "1rem",
                fontWeight: "bold",
                borderRadius: "6px",
                transition: "all 0.3s ease",
                boxShadow: "0 4px 6px rgba(0,0,0,0.1)"
              }}
              onClick={() => window.open("https://itetlax.org.mx/assets/pdf/ListadoCasillasAct.pdf", "_blank")}
            >
              Listado Ubicación de Casillas (PDF)
            </button>
            
          
          </div>
        </Modal.Body> */}
      {/* </Modal> */}

      {/* Preview hover (solo en modo clásico) */}
      {hoveredItem && !esModoCuadros && (
        <div 
          className="position-absolute shadow-lg"
          style={{
            zIndex: 1000,
            width: `${getDynamicHeight() * 2.2}px`, 
            height: `${getDynamicHeight() * 2.2}px`,
            top: `${hoverPosition.top}px`,
            left: `${hoverPosition.left}px`,
            transition: 'opacity 0.2s ease',
            backgroundColor: 'white',
            borderRadius: '8px',
            padding: '10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            pointerEvents: 'none',
            transform: 'translateY(20px)' 
          }}
        >
          <img
            src={hoveredItem.url}
            className="img-fluid"
            alt={hoveredItem.alt}
            style={{
              maxWidth: '100%',
              maxHeight: '100%',
              objectFit: 'contain',
              display: 'block'
            }}
          />
        </div>
      )}

      {/* Carrusel */}
      <div 
        id={itemsID}
        className={`carousel slide mt-3 ${esModoCuadros ? 'docs-cuadros' : ''}`.trim()} 
        data-bs-ride="carousel"
        data-bs-touch="true"
      >
        <div className="carousel-inner">
          {groups.map((group, index) => (
            <div 
              key={`slide-${index}`}
              className={`carousel-item ${index === 0 ? 'active' : ''}`}
            >
              {esModoCuadros ? (
                /* Modo Cuadros (Tablet y PC >= 768px): Cuadros uniformes tipo música con texto debajo */
                <div className="docs-grid">
                  {group.map((item, itemIndex) => {
                    const tituloDoc =
                      item.titulo ||
                      item.title ||
                      (item.alt && item.alt.trim().toLowerCase() !== "listado"
                        ? item.alt
                        : null);
                    const subDoc =
                      item.descripcion ||
                      item.description ||
                      item.subtitulo ||
                      item.year ||
                      item.anio ||
                      null;
                    const tieneLink = Boolean(item.link);

                    return (
                      <div 
                        key={`item-${item.id}-${index}-${itemIndex}`} 
                        className="docs-card-item"
                      >
                        <a 
                          href={tieneLink ? item.link : undefined} 
                          target={tieneLink ? "_blank" : undefined} 
                          rel={tieneLink ? "noopener noreferrer" : undefined} 
                          className={`docs-card ${!tieneLink ? "docs-card--sin-link" : ""}`.trim()}
                          aria-label={tituloDoc ? `Leer ${tituloDoc}` : "Leer documento"}
                          onClick={(e) => {
                            if (!tieneLink) e.preventDefault();
                          }}
                        >
                          <div className="docs-cuadro">
                            <img
                              src={item.url}
                              className="docs-img"
                              alt={tituloDoc || item.alt || "Documento"}
                              loading="lazy"
                            />
                            {tieneLink && (
                              <span className="docs-leer" aria-hidden="true">
                                <svg
                                  width="40"
                                  height="40"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth="1.8"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                >
                                  <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
                                  <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
                                </svg>
                              </span>
                            )}
                          </div>
                        </a>
                      </div>
                    );
                  })}
                </div>
              ) : (
                /* Modo Clásico / Móvil (< 768px): Intacto */
                <div className="row g-3 justify-content-center">
                  {group.map((item, itemIndex) => (
                    <div 
                      key={`item-${index}-${itemIndex}`} 
                      className={`col-${12/groupSize} col-md-${12/groupSize} position-relative`}
                      style={{ height: `${getDynamicHeight()}px` }}
                    >
                      <div 
                        className="h-100 w-100 hover-zoom-container"
                        onMouseEnter={(e) => handleMouseEnter(item, e)}
                        onMouseLeave={() => setHoveredItem(null)}
                        onClick={() => {
                          if(item.id === 3) {
                            handleOpenModal(item.url);
                          }
                        }}
                      >
                        <a 
                          href={item.id === 3 ? "#" : item.link} 
                          target="_blank" 
                          rel="noreferrer" 
                          className="text-decoration-none h-100 w-100"
                          onClick={(e) => {
                            if(item.id === 3) {
                              e.preventDefault();
                            }
                          }}
                        >
                          <div className="card border-0 bg-white h-100">
                            <img
                              src={item.url}
                              className="img-fluid rounded h-100 w-100 hover-zoom-image"
                              alt={item.alt}
                              style={{
                                objectFit: 'contain',
                                padding: '5px',
                                cursor: item.id === 3 ? 'pointer' : 'default'
                              }}
                            />
                          </div>
                        </a>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target={`#${itemsID}`}
          data-bs-slide="prev"
          style={{
            left: windowWidth < 768 ? '10px' : '-40px',
            top: '50%', 
            width: '40px',
            height: '40px',
            transform: 'translateY(-50%)'
          }}
        >
          <span className="carousel-control-prev-icon" aria-hidden="true" />
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target={`#${itemsID}`}
          data-bs-slide="next"
          style={{
            right: windowWidth < 768 ? '10px' : '-40px',
            top: '50%',
            width: '40px',
            height: '40px',
            transform: 'translateY(-50%)'
          }}
        >
          <span className="carousel-control-next-icon" aria-hidden="true" />
        </button>
      </div>

      <style jsx global>{`
        .custom-modal .modal-content {
          overflow: hidden;
          border-radius: 12px;
          border: none;
          max-width: 900px;
          margin: 0 auto;
        }
        
        .btn-hover-effect:hover {
          transform: translateY(-3px);
          box-shadow: 0 6px 12px rgba(0,0,0,0.15) !important;
          opacity: 0.95;
          cursor: pointer;
        }
        
        .btn-hover-effect:active {
          transform: translateY(1px);
        }

        @media (min-width: 992px) {
          .custom-modal .modal-body {
            flex-direction: row !important;
            align-items: center;
          }
          .custom-modal .modal-body > div:first-child {
            width: 60% !important;
            height: 100% !important;
            max-height: none !important;
            min-height: 100% !important;
          }
          .custom-modal .modal-body > div:last-child {
            width: 40% !important;
            height: 100% !important;
            justify-content: center;
            padding-top: 0 !important;
            padding-bottom: 0 !important;
          }
        }

        @media (max-width: 991.98px) {
          .custom-modal .modal-body > div:first-child {
            height: 50vh !important;
            max-height: none !important;
          }
          .custom-modal .modal-body > div:last-child {
            min-height: fit-content;
          }
        }

        .hover-zoom-container {
          overflow: hidden;
          position: relative;
        }
        .hover-zoom-image {
          transition: all 0.3s ease;
        }
        .hover-zoom-image:hover {
          transform: scale(1.20);
          box-shadow: 0 4px 8px rgba(0,0,0,0.1);
        }
      `}</style>
    </div>
  );
};

export default Informes;